import React from 'react';
import Widget from '../../components/widget';
import { withCampaignWidgets } from '../../analyticsWidgets';

const WidgetGrid = ({
  appliedFilters,
  filteredWidgets,
  handleError,
  eventHandlers,
  lastUpdated,
  customDashboard,
  isBrand,
  portal
}) => {
  if (!filteredWidgets) {
    return null;
  }

  const schemaHasColumn = column => {
    return (
      appliedFilters?.selectedSolution?.schema &&
      appliedFilters?.selectedSolution?.schema?.some(field => field.name === column)
    );
  };

  return withCampaignWidgets(filteredWidgets, customDashboard).map((row, index) => {
    if (!appliedFilters.selectedSolution) {
      return null;
    }

    // TODO: GET THIS INFO ON DEVICE LEVEL
    let filteredRow = row;

    // Remove wifi widgets if there is no wifi device selected
    if (appliedFilters.wifiDevices && appliedFilters.wifiDevices.length === 0) {
      filteredRow = row.filter(widget => !widget?.wifiTracker);
    }

    // Remove heatmap widgets if there is no heatmap device selected
    if (appliedFilters.heatmapDevices && appliedFilters.heatmapDevices.length === 0) {
      filteredRow = filteredRow.filter(widget => widget?.display !== 'heatmap');
    }

    // Sales Uplift depends on Point of Sale data and is only available for portals with POS enabled.
    if (isBrand && !portal?.activeFeatures?.includes('POS')) {
      filteredRow = filteredRow.filter(widget => widget?.display !== 'pos');
    }

    // Prevent errors when current project/table doesn't have required columns
    filteredRow = filteredRow.filter(
      widget => !widget?.requiredColumns || widget?.requiredColumns.every(schemaHasColumn)
    );

    // Filter widget that doesn't match renderCondition
    filteredRow = filteredRow.filter(widget => {
      if (!widget?.renderCondition) return true;

      const renderCondition = new Function('filters', widget?.renderCondition);
      return renderCondition(appliedFilters);
    });

    // Shouldn't render empty rows
    if (filteredRow.length === 0) {
      return null;
    }

    return (
      <div key={`row-${index}}`} className="chart-row">
        {filteredRow.map(widget => {
          return (
            <Widget
              key={`analytics-${widget?.id}`}
              widget={widget}
              lastUpdated={lastUpdated}
              filters={appliedFilters}
              handleError={handleError}
              eventHandlers={eventHandlers}
              collection={'ANALYTICS'}
              customDashboard={customDashboard}
              isBrand={isBrand}
              portal={portal}
            />
          );
        })}
      </div>
    );
  });
};

export default WidgetGrid;
